<template>
  <v-col cols="12" class="list pa-0 ">
    <iframe class="a4" :srcdoc="view" ref="frame"></iframe>
  </v-col>
</template>

<script>
import Renderer from "../../plugins/renderer";
import EditorView from "./EditorView";
import { debounce } from "lodash";
export default {
  name: "FieldsEditor",
  props: [
    "value",
    "template",
    "locale",
    "localization",
    "customRenderer",
    "staticView"
  ],
  data: () => ({
    dynamicView: ""
  }),
  methods: {
    renderEditorView: debounce(async function() {
      if (this.staticView || !(this.template?.content ?? undefined)) {
        return;
      }
      const template = await this.renderer.render(
        this.template.content,
        this.value,
        {
          locale: this.locale,
          timezone: "UTC",
          localization: this.localization
        }
      );
      const path = process.env.VUE_APP_PUBLIC_PATH || window.location.origin;
      this.dynamicView = EditorView(template, window.location.origin, path);
    }, 300),
    handleViewMessage(event) {
      if (!event || (event.data?.type ?? "unknown") !== "valuesupdated") {
        return;
      }
      // update our context with the user updated values from the view
      let input = {};
      for (const [key, value] of Object.entries(event.data.inputs)) {
        if (key.startsWith("DocInp_")) {
          input[key.substring("DocInp_".length)] = value;
        }
      }
      this.updateInput(input);
    },
    updateInput(values) {
      const input = {
        ...this.value,
        ...values
      };
      this.$emit("input", input);
    }
  },
  computed: {
    renderer: function() {
      return this.customRenderer ? this.customRenderer : new Renderer();
    },
    view: function() {
      return this.staticView ?? this.dynamicView;
    }
  },
  mounted: function() {
    this.renderEditorView();
    window.addEventListener("message", this.handleViewMessage, false);
  },

  destroyed: function() {
    window.removeEventListener("message", this.handleViewMessage);
  },

  watch: {
    template: function() {
      this.renderEditorView();
    },
    "template.content": function() {
      this.renderEditorView();
    },
    value: function() {
      this.renderEditorView();
    },
    locale: function() {
      this.renderEditorView();
    }
  }
};
</script>
<style scoped>
.list {
  width: 21cm;
  font-size: 0;
  background: #fff;
  display: inline-block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  overflow: auto;
}
.a4 {
  width: 21cm;
}
iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
